export default (storeState, { payload }) => {
  let newState = Object.assign({}, storeState);

  let index = newState.index

  if (payload.indexBlockData !== undefined) {
    index = payload.indexBlockData + 1
    payload = Object.assign({}, payload)
  }

  const sorts = newState.asideData
    .map(o => o.sort)
    .filter(s => typeof s === 'number');

  const maxSort = sorts.length ? Math.max(...sorts) : 0;

  payload.sort = maxSort + 1;

  newState.asideData.splice(index, 0, payload);

  newState.asideData = [...newState.asideData]

  return newState;
};
